import React from 'react';
import { chairSupport, frontierThemes } from '../data/portfolio';
import { Label } from './Label';
export function CurrentAppointment() {
  return <section id="appointment" aria-labelledby="appointment-heading" className="mesh scroll-mt-20 px-6 py-24 md:px-10 md:py-32" data-id="element-112" data-mp="3bdeww9ter7o7">
      <div className="relative z-[1] mx-auto w-full max-w-edge" data-id="element-113" data-mp="3kc0kijdqlcvu">
        <Label data-id="element-114" data-mp="3kemok91f5a9b">Current Board Appointment</Label>

        <div className="mt-10 grid gap-10 lg:grid-cols-12 lg:gap-16" data-id="element-115" data-mp="25lz5zd520nf">
          <div className="lg:col-span-7" data-id="element-116" data-mp="3uazjtbcm3w66">
            <h2 id="appointment-heading" className="font-display text-[2.75rem] font-normal leading-[1.02] text-paper md:text-[4.5rem]" data-id="element-117" data-mp="3u9y6f084ixla">
              Frontier IP
              <br data-id="element-118" data-mp="6y5lpltt064d" />
              Group plc
            </h2>
            <p className="mt-6 text-sm uppercase tracking-[0.22em] text-brass" data-id="element-119" data-mp="ltuzwxsqzeyj">
              LSE:FIPP · Independent NED · 2023 — Present
            </p>
          </div>
          <div className="lg:col-span-5 lg:pt-4" data-id="element-120" data-mp="1nvv65i2sfgbn">
            <p className="font-display text-xl font-normal leading-[1.5] text-paper/90 md:text-2xl" data-id="element-121" data-mp="1nx6kgbtv06h0">
              An LSE listed company holding a portfolio of high technology companies — where
              operating, investment and governance experience are applied in the same room.
            </p>
          </div>
        </div>

        <div className="mt-20 grid border-t border-white/15 md:grid-cols-2 lg:grid-cols-4" data-id="element-122" data-mp="21tjs6t8lctia">
          {frontierThemes.map(theme => <div key={theme.theme} className="border-b border-white/10 py-10 lg:border-b-0 lg:border-r lg:px-8 lg:last:border-r-0 lg:first:pl-0 lg:last:pr-0 md:px-0 md:py-12" data-id="element-123" data-mp="2btal4qhi70g9">
              <h3 className="text-[11px] font-medium uppercase tracking-[0.3em] text-brass" data-id="element-124" data-mp="2kl2roq3eppfk">
                {theme.theme}
              </h3>
              <ul className="mt-6 space-y-5" data-id="element-125" data-mp="2pj4dhis7w2uq">
                {theme.items.map(item => <li key={item} className="text-[0.95rem] leading-relaxed text-paper/85 md:text-base" data-id="element-126" data-mp="2ui7hczwgo314">
                    {item}
                  </li>)}
              </ul>
            </div>)}
        </div>

        <figure className="mt-16 border-t border-white/15 pt-10 md:mt-20" data-id="element-127" data-mp="1496oophgccb6">
          <blockquote className="max-w-3xl font-display text-2xl font-normal leading-[1.4] text-paper md:text-[2.25rem]" data-id="element-128" data-mp="zgdhzw2fatwg">
            “{chairSupport}”
          </blockquote>
        </figure>
      </div>
    </section>;
}